import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NotificationListItem from './NotificationListItem'

export default function NotificationList({ notifications, onReaded }) {
  return (
    <>
      {notifications.map((notification, i) => (
        <Row key={i} className="pt-2 pb-2 border-bottom">
          <Col>
            <NotificationListItem notification={notification} onReaded={(value) => onReaded(value)} />
          </Col>
        </Row>
      ))}
    </>
  )
}
